import React from 'react';
import { Popover } from 'antd';
import classNames from 'classnames';
import { ContactTag } from '../../../../domain/models/Contact';
import { CONTACT_HEAT_LABELS, ContactHeatLevel } from '../types/ContactDisplay';

export const ContactHeatPill: React.FC<{ heat: ContactTag | null; level: ContactHeatLevel | null }> = ({ heat, level }) => {
  if (!heat) return null;
  return (
    <span className={classNames('contacts__heat', level && `contacts__heat--${level}`)}>
      <span className="contacts__heat-dot" />
      {level ? CONTACT_HEAT_LABELS[level] : heat.name}
    </span>
  );
};

interface ContactTagListProps {
  tags: ContactTag[];
  // Chips shown before the rest is folded into "+N"; every tag when absent
  max?: number;
  // Title of the hover panel listing every tag, shown when some are folded into "+N"
  title?: string;
}

const renderTags = (tags: ContactTag[]) =>
  tags.map((tag) => (
    <span key={tag.id} className="contacts__tag">
      {tag.name}
    </span>
  ));

export const ContactTagList: React.FC<ContactTagListProps> = ({ tags, max, title }) => {
  if (tags.length === 0) return null;
  const shown = max === undefined ? tags : tags.slice(0, max);
  const hidden = tags.slice(shown.length);
  const list = (
    <span className="contacts__tags">
      {renderTags(shown)}
      {hidden.length > 0 && <span className="contacts__tag contacts__tag--more">+{hidden.length}</span>}
    </span>
  );
  if (hidden.length === 0) return list;

  return (
    <Popover
      placement="top"
      mouseEnterDelay={0.2}
      content={
        <div className="contacts__tags-popover">
          {title && <div className="contacts__tags-popover-title">{title}</div>}
          <span className="contacts__tags">{renderTags(tags)}</span>
        </div>
      }
    >
      {list}
    </Popover>
  );
};

export const ContactFollowedBy: React.FC<{ label: string; isOwn: boolean }> = ({ label, isOwn }) => (
  <span className={classNames('contacts__owner', { 'contacts__owner--own': isOwn })}>
    <span className="contacts__owner-dot" />
    {label}
  </span>
);
